import React, { useRef, useEffect } from 'react'
import { useLocation } from 'react-router'
import clsx from 'clsx'
import { AsideMenuMain } from './AsideMenuMain'
import { AsideMenuSupperAdmin } from './AsideMenuSupperAdmin'
import { AsideMenuChiefOffice } from './AsideMenuChiefOffice'
import { AsideMenuManage } from './AsideMenuManage'
import { AsideMenuRepresentativeOffice } from './AsideMenuRepresentativeOffice'
import { AsideMenuLeader } from './AsideMenuLeader'
import { AsideMenuTraining } from './AsideMenuTraining'
import { AsideMenuShareholder } from './AsideMenuShareholder'
import { DrawerComponent, ScrollComponent, ToggleComponent } from '../../../assets/ts/components'
import { useAuth } from '../../../../app/modules/auth'
import { CONSTANT } from '../../../../constant'

type Props = {
  asideMenuCSSClasses: string[]
}

const AsideMenu: React.FC<Props> = ({ asideMenuCSSClasses }) => {
  const scrollRef = useRef<HTMLDivElement | null>(null)
  const { pathname } = useLocation()
  const { currentUser } = useAuth()
  let asideMenuMain = <AsideMenuMain />

  if (currentUser) {
    switch (currentUser.role?.slug) {
      case CONSTANT.ROLE.SUPER_ADMIN:
        asideMenuMain = <AsideMenuSupperAdmin />
        break;
      case CONSTANT.ROLE.CHIEF_OFFICE:
        asideMenuMain = <AsideMenuChiefOffice />
        break;
      case CONSTANT.ROLE.MANAGER:
        asideMenuMain = <AsideMenuManage />
        break;
      case CONSTANT.ROLE.REPRESENTATIVE_OFFICE:
        asideMenuMain = <AsideMenuRepresentativeOffice />
        break;
      case CONSTANT.ROLE.LEADER:
        asideMenuMain = <AsideMenuLeader />
        break;
      case CONSTANT.ROLE.TRAINING:
        asideMenuMain = <AsideMenuTraining />
        break;
      case CONSTANT.ROLE.SHAREHOLDER:
      case CONSTANT.ROLE.CUSTOMER_CARE:
        asideMenuMain = <AsideMenuShareholder />
        break;
    }
  }

  useEffect(() => {
    setTimeout(() => {
      DrawerComponent.reinitialization()
      ToggleComponent.reinitialization()
      ScrollComponent.reinitialization()
      if (scrollRef.current) {
        scrollRef.current.scrollTop = 0
      }
    }, 50)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  return (
    <div
      id='kt_aside_menu_wrapper'
      ref={scrollRef}
      className='hover-scroll-overlay-y my-5 my-lg-5'
      data-kt-scroll='true'
      data-kt-scroll-activate='{default: false, lg: true}'
      data-kt-scroll-height='auto'
      data-kt-scroll-dependencies='#kt_aside_logo, #kt_aside_footer'
      data-kt-scroll-wrappers='#kt_aside_menu'
      data-kt-scroll-offset='0'
    >
      <div
        id='#kt_aside_menu'
        data-kt-menu='true'
        className={clsx(
          'menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500',
          asideMenuCSSClasses.join(' ')
        )}
      >
        {asideMenuMain}
      </div>
    </div>
  )
}

export { AsideMenu }
